import React, { useEffect, useRef, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { LayoutModal } from '../../templates/layout-modal/layout-modal'
import Button from '../../atoms/button/button'
import './modalTalk.scss'
import { concourseId } from '../../../constants/activity-constants'
import ForumServices from '../../../services/forum-service'
import userSessionStorage from '../../../utils/userSessionStorage'
import { triggerTag } from '../../../utils/taggeo'

const OPINION_STATES = {
  idle: 0,
  loading: 1,
  sended: 2,
}
type TForumData = {
  forumId: number
}
const getForumByConcourseId = () => {
  return ForumServices.getForumByConcourseId(concourseId!).then((res: any) => {
    if (res.status === 200) {
      return res.data[0]
    } else {
      return null
    }
  })
}

async function sendComment(forumId: number, text: string) {
  try {
    const session = new userSessionStorage()
    const token = session.getToken()
    if (!token) {
      return false
    }
    const config = {
      headers: {
        Authorization: token.idToken,
      },
    }
    const res = await ForumServices.saveForumComment(forumId, text, config)
    return res
  } catch (error) {
    console.log(error)
  }
}
const BG = () => (
  <div className="f-modalTalk-background">
    <div className="f-modalTalk-background__image">
      <StaticImage
        src="../../../assets/images/talk.png"
        alt="Logo v-school"
        title="Logo v-school"
        width={480}
        placeholder="blurred"
      />
    </div>
  </div>
)
interface IErrorMsg {
  status: string
  message: string
}
const ModalTalk = ({ close }: { close: () => void }) => {
  const refTextArea = useRef(null)
  const [forumData, setForumData] = useState(null)
  const [state, setState] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<IErrorMsg>()
  const [canSend, setCanSend] = useState(false)
  const handlerOmitir = () => {
    triggerTag('15A', { label: 'Omitir' })
    close()
  }
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    let textAreaDom = refTextArea.current! as HTMLTextAreaElement
    let text = textAreaDom.value
    if (!forumData) {
      return
    }
    if (text.trim().length < 3) {
      return
    }
    setState(OPINION_STATES.loading)

    // SENDING HERE
    sendComment((forumData as TForumData).forumId, text).then(
      (response: any) => {
        if (response.status !== 200) {
          triggerTag('15A', { label: 'Enviar' })
          /* setState(OPINION_STATES.idle) 
        setUserMessage(response.userMessage|| "no se pudo guar") */
        }
        setState(OPINION_STATES.sended)
        close()
      }
    )

    //setState(OPINION_STATES.sended)
  }

  useEffect(() => {
    let alive = true

    getForumByConcourseId().then((forumData: any) => {
      if (!alive) {
        return
      }
      if (!forumData) {
        console.error('no forum id asociated')
        return
      }
      setForumData(forumData)
    })
    return () => {
      alive = false
    }
  }, [])
  return (
    <LayoutModal childrenBG={BG()} close={close} className="f-modalTalk">
      <>
        <h2>¡Hablemos!</h2>
        <p>
          Tu opinión es muy importante para nosotras.
          <br />
          <b>¡Cuéntanos tu experiencia con los juegos!</b>
        </p>
        <form onSubmit={onSubmit}>
          <textarea
            ref={refTextArea}
            placeholder="¿Qué fue lo que más te gustó?, ¿qué debemos mejorar?"
            id="hablemos"
            name="hablemos"
            maxLength={500}
            onChange={e => {
              if (e.target.value.trim().length === 0) {
                setCanSend(false)
                return true
              } else {
                setCanSend(true)
              }
              if (
                !/^[  a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/.test(
                  e.target.value
                )
              ) {
                return false
              }
            }}
          />
          {errorMessage?.message && (
            <span className="f-errorMessage">{errorMessage.message}</span>
          )}

          <Button
            title="Enviar"
            type="submit"
            loading={isLoading}
            className="f-modalTalk-button"
            disabled={!canSend}
          >
            Enviar
          </Button>
          <Button className="f-modalTalk-btnOmit" onClick={handlerOmitir}>
            Omitir
          </Button>
        </form>
      </>
    </LayoutModal>
  )
}

export default ModalTalk
